<ng-container [ngSwitch]="mode">
  <div class="empty" *ngSwitchCase="'block'">
    <div class="ec">
      <ng-content select="[empty-icon]"></ng-content>
    </div>
    <div class="et">{{ title }}</div>
    <div class="em" *ngIf="message">{{ message }}</div>
    <button class="btn sm" style="margin-top:14px" *ngIf="actionLabel" (click)="action.emit()">{{ actionLabel }}</button>
  </div>

  <div class="emptyline" *ngSwitchCase="'line'">
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2zm0-4h-2V7h2z"/></svg>
    {{ message }}
  </div>
</ng-container>
